var image_upload_default = {
  "container": "EAB-6",
  "disabled": "Ejsig",
  "imageInput": "AtZnc",
  "overlay": "x3wyO",
  "text": "AHJc0",
  "shown": "r3-Aw",
  "hide": "sunub",
  "spinner": "BRV4v",
  "spin": "Gb8HP"
};
export {
  image_upload_default as default
};
//# sourceMappingURL=image-upload-scss.js.map
